import VuexPersistence from 'vuex-persist'

const PERSISTENCE_KEY = 'portal-session'

const vuexLocal = new VuexPersistence({
  key: PERSISTENCE_KEY,
  storage: window.sessionStorage
})

const globalStoreConfig = {
  // use short names so namespacing can be used properly
  modules: {
  },
  state: {
    brand: null,
    retailerId: null,
    deliveryType: null,
    client: null,
    baseUrl: process.env.VUE_APP_API_BASE_URL
  },
  mutations: {
    selectBrand: (state, brand) => {
      state.brand = brand
    },
    selectRetailerId: (state, retailerId) => {
      state.retailerId = retailerId
    },
    selectType: (state, type) => {
      state.deliveryType = type
    },
    selectClient: (state, client) => {
      state.client = client
    },
    selectBaseUrl: (state, baseUrl) => {
      state.baseUrl = baseUrl
    }
  },
  actions: {
    clearState ({ commit }) {}
  },
  getters: {
    brand: (state) => state.brand,
    retailerId: (state) => state.retailerId,
    deliveryType: (state) => state.deliveryType,
    clientId: (state) => state.client?.id || '',
    clientSecret: (state) => state.client?.secret || '',
    baseUrl: (state) => state.baseUrl
  },
  plugins: [vuexLocal.plugin],
  devtool: process.env.NODE_ENV !== 'production' // disable devtool in production
}

export { globalStoreConfig, PERSISTENCE_KEY }
